<template>
   <div class="card main-page" style=" overflow: hidden;">
      <div class="card-body m-2">
         <div class="row p-2 mb-3">
            <div class="d-row d-flex align-items-center">

               <!-- <div class="col-1">
                  <input type="text" class="form-control form-control-sm rounded-pill"
                     placeholder="&#xF002; Search Logs..." @keyup="onSearch()"
                     style="font-size: 15px; font-family: 'Roboto', sans-serif, 'Font Awesome 6 Free';" />
               </div> -->

               <div class="ms-2 col-6 button-container">
                  <button type="button" class="fw-bold btn btn-info-outline rounded-pill btn-sm"
                     style="font-size: 15px; width: 100px;" @click="copyToClipBoard()">
                     <i class="fa-regular fa-copy"></i>
                     Copy
                  </button>

                  <button type="button" class="fw-bold btn btn-info-outline rounded-pill btn-sm"
                     style="font-size: 15px; width: 100px;" @click="exportLogData('csv')">
                     <i class="fa-regular fa-file-csv"></i>
                     CSV
                  </button>

                  <button type="button" class="fw-bold btn btn-info-outline rounded-pill btn-sm"
                     style="font-size: 15px; width: 100px;" @click="exportLogData('xls')">
                     <i class="fa-regular fa-file-excel"></i>
                     Excel
                  </button>

                  <button type="button" class="fw-bold btn btn-info-outline rounded-pill btn-sm"
                     style="font-size: 15px; width: 100px;" disabled>
                     <i class="fa-regular fa-file-pdf"></i>
                     PDF
                  </button>

                  <button type="button" class="fw-bold btn btn-info-outline rounded-pill btn-sm"
                     style="font-size: 15px; width: 100px;" disabled @click="showPrintPreview()">
                     <i class="fa-regular fa-print"></i>
                     Print
                  </button>
               </div>

               <!-- FILTERS -->
               <div class="col-6 d-flex flex-row justify-content-start">

                  <div class="d-flex flex-row align-items-center">
                     <span class="p-2 filter-title">Login:</span>
                     <select v-model="filterLoginBy" class="form-select shadow-none filter-options"
                        style="width:auto;border:none">
                        <option v-for="filter in filterLogin" :value="filter.value" :key="filter.value">{{
                           filter.text }}
                        </option>
                     </select>
                  </div>

                  <div class="d-flex flex-row align-items-center">
                     <span class="p-2 filter-title">OAuth:</span>
                     <select v-model="filterOAuthBy" class="form-select shadow-none filter-options"
                        style="width:auto;border:none">
                        <option v-for="filter in filterOAuth" :value="filter.value" :key="filter.value">{{
                           filter.text }}
                        </option>
                     </select>
                  </div>

                  <div class="d-flex flex-row align-items-center">
                     <span class="p-2 filter-title">Sort by:</span>
                     <select v-model="sortBy" class="form-select shadow-none filter-options"
                        style="width:auto;border:none">
                        <option v-for="sortBy in sortByList" :value="sortBy.value" :key="sortBy.value">{{ sortBy.text }}
                        </option>
                     </select>
                  </div>

                  <div class="d-flex flex-row align-items-center">
                     <span class="p-2 filter-title">Rows Per Page:</span>
                     <select v-model="pagination.pageSize"
                        class="form-select form-select-sm shadow-none filter-options">
                        <option v-for="row in rowsPerPageList" :value="row.value" :key="row.value">{{ row.text }}
                        </option>
                     </select>
                  </div>

               </div>

            </div>
         </div>

         <!-- History Filter Start -->
         <div class="row">
            <div class="mb-6">
               <div class="card border">
                  <div class="card-body">
                     <div class="row">
                        <div class="col-4 mt-2">
                           <div class="form-group">
                              <label for="inputKeyWord"
                                 style="padding-bottom: 5px; padding-left: 15px; font-size: 13px;">Search
                                 keyword(s)</label>
                              <input type="text" class="form-control rounded-pill" v-model="filters['keyword']"
                                 @keyup="onSearch()" placeholder="Enter website, extension name, or extension key...">
                           </div>
                        </div>

                        <div class="col-2 mt-2">
                           <div class="form-group">
                              <label style="padding-bottom: 5px; padding-left: 15px; font-size: 13px;">Status</label>
                              <select class="form-select rounded-pill" v-model="filters['is_safe']"
                                 aria-label="Select Etension API Key" @change="onSearch()">
                                 <option v-for="(val, key) in statusOptions" :key="key" :value="val">{{ key }}
                                 </option>
                              </select>
                           </div>
                        </div>

                        <div class="col-3 mt-2">
                           <div class="form-group">
                              <div class="row">
                                 <div class="col-6">
                                    <label style="padding-bottom: 5px; padding-left: 3%; font-size: 13px;">Date
                                       From</label>
                                 </div>
                                 <div class="col-6">
                                    <label style="padding-bottom: 5px; padding-left: 3%; font-size: 13px;">Date
                                       To</label>
                                 </div>
                              </div>

                              <div class="row">
                                 <div class="col">
                                    <div class="button-container">
                                       <div class="input-group date" id="datepicker">
                                          <input type="date" class="form-control rounded-pill" id="date"
                                             min="1979-12-31" max="2100-12-31" @keydown="preventKeyPress($event)"
                                             :formatter="formatDateTo" @change="onSearch()"
                                             v-model="filters['date_from']" />
                                       </div>
                                       <div class="input-group date" id="datepicker">
                                          <input type="date" class="form-control rounded-pill" id="date"
                                             min="1979-12-31" max="2100-12-31" @keydown="preventKeyPress($event)"
                                             :formatter="formatDateFrom" @change="onSearch()"
                                             v-model="filters['date_to']" />
                                       </div>
                                    </div>
                                 </div>
                              </div>



                              <!-- <label style="padding-bottom: 5px; padding-left: 3%; font-size: 13px;">Date From</label>
                              <label style="padding-bottom: 5px; padding-left: 32.5%; font-size: 13px;">Date To</label> -->
                              <!-- <div class="button-container">
                                 <div class="input-group date" id="datepicker">
                                    <input type="date" class="form-control rounded-pill" id="date" min="1979-12-31"
                                       max="2100-12-31" @keydown="preventKeyPress($event)" @change="onSearch()"
                                       v-model="filters['date_from']" />
                                 </div>
                                 <div class="input-group date" id="datepicker">
                                    <input type="date" class="form-control rounded-pill" id="date" min="1979-12-31"
                                       max="2100-12-31" @keydown="preventKeyPress($event)" :formatter="formatDateFrom"
                                       @change="onSearch()" v-model="filters['date_to']" />
                                 </div>
                              </div> -->
                           </div>
                        </div>

                        <div class="col-3 mt-2">
                           <div class="form-group">
                              <label style="padding-bottom: 5px; padding-left: 15px; font-size: 13px;">Upload Size
                                 (Kb)</label>
                              <div class="button-container">
                                 <input type="numeric" class="form-control rounded-pill" @keypress="isNumber($event)"
                                    @keyup="onSearch()" v-model="filters['min_upload_size']" placeholder="Minimum...">
                                 <input type="numeric" class="form-control rounded-pill" @keypress="isNumber($event)"
                                    @keyup="onSearch()" v-model="filters['max_upload_size']" placeholder="Maximum...">
                              </div>
                           </div>
                        </div>

                        <div class="col-1 mt-2">

                        </div>
                     </div>

                     <!-- <div class="row">
                        <div class="col-3 mt-3 mb-3">
                           <div class="form-group">
                              <label style="padding-bottom: 5px; padding-left: 15px; font-size: 13px;">Status</label>
                              <select class="form-select rounded-pill" v-model="filters['is_safe']"
                                 aria-label="Select Etension API Key" @change="onSearch()">
                                 <option v-for="(val, key) in statusOptions" :key="key" :value="val">{{ key }}
                                 </option>
                              </select>
                           </div>
                        </div>

                        <div class="col-3 mt-3 mb-3">

                        </div>

                        <div class="col-4 mb-3 mt-3">

                        </div>
                     </div> -->
                  </div>
               </div>
            </div>

            <!-- <div class="col-4"></div> -->
         </div>
         <!-- History Filter End -->

         <!-- History Table Start -->
         <div class="row p-2 mt-2 tbodyDive table-responsive" id="infinite_table">
            <table class="table align-middle main-table">
               <thead class="align-middle">
                  <tr>
                     <template v-for="header in headers" :key="header.value">
                        <th class="tr-color-light" scope="col"
                           :hidden="(header.text == 'Version' || header.text == 'Browser') && !this.$store.state.auth.isSuperAdmin">
                           {{ header.text }}
                        </th>
                     </template>

                  </tr>
               </thead>

               <tbody v-if="this.logs.length <= 0">
                  <tr>
                     <td colspan="4">
                        No records to display.
                     </td>
                  </tr>
               </tbody>

               <tbody class="tbody-flow">
                  <tr v-for="(log, index) in logs" :key="index">
                     <td data-toggle="tooltip" data-placement="bottom" style="max-width: 50px;" :title="log.api_key">{{
                        (!log.apikey_name == null || !log.apikey_name == "") ? truncateText(log.apikey_name, 15) :
                           (!log.host_name == null || !log.host_name == "") ? truncateText(log.host_name, 20) :
                              truncateText(log.api_key, 20)
                     }}</td>
                     <td data-toggle="tooltip" data-placement="bottom" :title="trimQuestionMark(log.url)"
                        style="max-width: 175px;">{{
                           trimQuestionMark(log.url) }}
                        <!-- truncateText( , 35) -->
                     </td>
                     <td style="max-width: 175px;" data-toggle="tooltip" data-placement="bottom"
                        :title="log.redirect_uri">
                        {{ log.redirect_uri }}
                        <!-- truncateText( , 35)-->
                     </td>
                     <td>{{ (log.filesize == null || log.filesize == 0) ? 0 : log.filesize / this.fileSizeDivisor }} Kb
                     </td>

                     <td class="text-color-yes text-center" style="padding-right: 5rem;"
                        v-if="log.has_password_field == 1"><i class="fa-solid fa-check"></i></td>
                     <td class="text-color-no text-center" style="padding-right: 5rem;" v-else><i
                           class="fa-solid fa-x"></i></td>
                     <!-- <td > {{ (log.has_password_field == 1) ? `` : `<i class="fa-solid fa-check"></i>` }}</td> -->
                     <td>{{ log.ip }}</td>
                     <td :class="getStatusClass(log.is_safe)">{{ getStatusName(log.is_safe, log.unsafe_code) }}</td>
                     <td :class="getTypeClass(log.block_type)">{{ log.block_type }}</td>
                     <td v-if="this.$store.state.auth.isSuperAdmin">{{ log.extension_version }}</td>
                     <td data-toggle="tooltip" :title="log.user_agent" v-if="this.$store.state.auth.isSuperAdmin">{{
                        (log.user_agent == null) ? "Old Version" : log.user_agent.includes("Edg")? "Edge" : log.user_agent.includes("Chrome") ? "Chrome" : log.user_agent.includes("Firefox") ? "Firefox" : "None"}}</td>
                     <td>{{ formatDateFromUTC(log.date_created) }}</td>
                  </tr>
               </tbody>

            </table>
         </div>
         <!-- History Table End -->

         <!-- START -- PAGINATION -->
         <div class="row text-center">
            <div class="d-inline pagination" style="padding-top: 20px;">
               <!-- <a @click="previousPage()" style="margin-right: 8px; color: #00a0c1;"
                  :style="this.pagination.page == 1 ? 'color: #ccc;' : 'cursor: pointer;'"
                  :disabled="this.pagination.page == 1">
                  <i class="fa fa-chevron-left"></i>
               </a> -->
               <span v-if="this.logCount >= this.pagination.pageSize" style="margin-left: 8px; color: #00a0c1;">
                  <strong>
                     <span> Scroll to load more items </span>
                  </strong>
               </span>
               <span v-else-if="this.logs.length != 0" style="margin-left: 8px; color: #ccc;">
                  <strong>
                     <span> No more records found </span>
                  </strong>
               </span>
               <br>
               <br>
               <span>
                  <strong>
                     <span> Total Items: {{ this.logs.length }} </span>
                  </strong>
               </span>
               <!-- <a @click="nextPage()" style="margin-left: 8px; color: #00a0c1;"
                  :style="this.logCount < this.pagination.pageSize ? 'color: #ccc;' : 'cursor: pointer;'"
                  :disabled="this.logCount < this.pagination.pageSize">
                  Load More Items
                  <i class="fa fa-chevron-right"></i>
               </a> -->
            </div>

         </div>
         <!-- END -- PAGINATION -->
      </div>
   </div>
   <!-- ========== END -- CARD ========== -->

   <div v-if="showTable" class="print-table">
      <!-- Print-friendly version of your table -->
      <!-- <b>Hello</b> -->
   </div>

   <LoadingScreen v-if="isLoading" />

</template>

<script>
import moment from 'moment'
import { debounce } from '@/plugins/helper.js'
import exportFromJSON from 'export-from-json'
import LoadingScreen from '@/components/Analytics/Log History/Loading.vue'

export default ({

   components: {
      LoadingScreen
   },
   el: '#infinite_table',
   data() {
      return {
         showTable: false,
         headers: [
            { text: "Extension Name/Key", value: "nameOrExtension" },
            { text: "Website", value: "website" },
            { text: "Redirect URL", value: "redirectURL" },
            { text: "Size (Kb)", value: "size_kb" },
            { text: "Login Field", value: "login_field" },
            { text: "IP", value: "ip" },
            { text: "Status", value: "status" },
            { text: "Block Type", value: "type" },
            { text: "Version", value: "extension_version" },
            { text: "Browser", value: "user_agent" },
            { text: "Date & Time", value: "dateCreated" },
         ],
         json_data: [
            {
               'name': 'Tony Peña',
               'city': 'New York',
               'country': 'United States',
               'birthdate': '1978-03-15',
               'phone': {
                  'mobile': '1-541-754-3010',
                  'landline': '(541) 754-3010'
               }
            },
            {
               'name': 'Thessaloniki',
               'city': 'Athens',
               'country': 'Greece',
               'birthdate': '1987-11-23',
               'phone': {
                  'mobile': '+1 855 275 5071',
                  'landline': '(2741) 2621-244'
               }
            }
         ],
         fileSizeDivisor: 1000,
         isLoading: false,
         search: "",
         filterActive: true,
         filters: {
            "keyword": null,
            "url": null,
            "email": null,
            "ext_api_key": null,
            "is_safe": -1,
            "date_from": new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().slice(0, 10),
            "date_to": new Date().toISOString().slice(0, 10),
            "min_upload_size": null,
            "max_upload_size": null,
            "has_password_field": false,
            "oauth": false,
         },
         extensionKeys: [],
         statusOptions: {
            "None": -1, "Safe": 1, "Unsafe": 0, "Unchecked": 2, "Blocked": 3
         },
         filterOAuth: [
            { text: "With OAuth", value: 1 },
            { text: "No OAuth", value: 0 },
            { text: "Both", value: 2 }
         ],
         filterOAuthBy: 2,
         filterLogin: [
            { text: "With Login", value: 1 },
            { text: "No Login", value: 0 },
            { text: "Both", value: 2 }
         ],
         filterLoginBy: 2,
         debounceFn: null,
         logs: [],
         logsExport: [],
         logsExportAll: [],
         paginationData: {},
         logCount: 0,
         isFromRowsPerPage: false,
         pagination: {
            pageSize: 50,
            page: 1,
            totalItems: 0,
            totalPages: 1,
         },
         rowsPerPageList: [
            { text: "50", value: 50 },
            { text: "75", value: 75 },
            { text: "100", value: 100 },
         ],
         sortByList: [
            { text: "Date: Newest", value: "dateCreated_desc" },
            { text: "Date: Oldest", value: "dateCreated_asc" },
         ],
         sortBy: "dateCreated_desc", //default option
         sorting: {
            field: "name",
            order: "desc"
         },
      }
   },

   computed: {

      currentPage() {
         return this.pagination.page
      },

      rowsPerPage() {
         return this.pagination.pageSize
      },

      sortItems() {
         return this.sortBy
      },

      filterByOAuth() {
         return this.filterOAuthBy
      },

      filterByLogin() {
         return this.filterLoginBy
      },
   },

   watch: {
      currentPage() {
         // if(this.isFromRowsPerPage == true) {
         //    this.isFromRowsPerPage = false
         //    this.pagination.page = 1
         // } else {
         //console.log(this.pagination.page, "hello")
         //this.getLogHistory()
         //}
      },

      filterByOAuth() {
         this.logs = []
         this.getLogHistory()
         this.pagination.page = 1

      },

      filterByLogin() {
         this.logs = []
         this.getLogHistory()
      },

      generateDownloadHeaders() {

      },

      rowsPerPage() {
         this.pagination.page = 1
         this.isFromRowsPerPage = true
         this.logs = []
         this.scrollTop()
         this.onScrollEnd()
         this.getLogHistory()
      },

      sortItems() {
         this.pagination.page = 1
         this.logs = []
         if (this.sortBy.includes("_")) {
            let sort = this.sortBy.split("_")
            this.sorting.field = sort[0]
            this.sorting.order = sort[1]
         } else {
            this.sorting.field = this.sortBy
            this.sorting.order = ""
         }
         this.getLogHistory()
      },
   },

   created() {
      this.init()
      // for setting the delay of calling the function when searching
      this.debounceFn = debounce(() => this.getLogHistory(), 500)
   },

   mounted() {
      this.onScrollEnd()
   },

   methods: {

      init() {

         this.getLogHistory()
         this.getExtensionKeys()
         // this.exportLogData()
      },

      scrollTop() {
         let div = document.querySelector("#infinite_table");
         div.removeEventListener("scroll", this.trialListener)
      },

      onScrollEnd() {
         let div = document.querySelector("#infinite_table");
         //console.log(this.$el)
         div.addEventListener(
            "scroll",
            this.trialListener,
            {
               passive: false
            }
         );

         div.divparam = div

      },

      trialListener(evt) {
         let div = evt.currentTarget.divparam
         if (Math.abs(div.scrollHeight - div.clientHeight - div.scrollTop) < 1 && this.isFromRowsPerPage == false) {
            if (this.pagination.pageSize <= this.logCount) {
               this.pagination.page += 1
               this.getLogHistory();
            }
         }

         this.isFromRowsPerPage = false;
      },

      async copyToClipBoard() {

         let data = []

         let logLen = 0

         if (this.logs != null) {
            logLen = this.logs.length

            for (let x = 0; x < logLen; x++) {
               data[x] = this.logs[x]
            }
         }


         if (data != null) {
            if (data.length > 0) {
               for (let logLen = 0; logLen < data.length; logLen++) {
                  delete data[logLen].account_id
                  delete data[logLen].apikey_id
                  delete data[logLen].id
                  data[logLen].date_created = this.formatDate(data[logLen].date_created)
               }
            }
         }

         var jsonString = JSON.stringify(data);

         // Use the Clipboard API to copy the string to the clipboard
         navigator.clipboard.writeText(jsonString).then(function () {

         }).catch(function (err) {
            console.error('Unable to copy object to clipboard.', err);
            return
         });

         this.$toast.success("Logs copied to clipboard.")
      },

      async exportLogData(str) {

         this.isLoading = true;

         await this.getLogsForExport().then(() => {

            setTimeout(() => {

               const fileName = this.$store.state.auth.organisation_name + '_log_history_' + moment()

               //console.log(this.logs)
               let data = []
               let exportType = null

               switch (str) {
                  case "csv": exportType = exportFromJSON.types.csv
                     break;
                  case "xls": exportType = exportFromJSON.types.xls
                     break;
               }

               //const exportType = exportFromJSON.types.xls

               // if(this.logs != null) {
               //    if (this.logs.length > 0) {
               //       for(let logLen = 0; logLen < this.logs.length; logLen++) {
               //             data.push({"url": this.logs[logLen].url})
               //       }
               //    }
               // }

               let logLen = 0

               if (this.logsExport != null) {
                  logLen = this.logsExport.length


                  //console.log(this.logsExport)
                  if (this.$store.state.auth.isSuperAdmin) {
                     for (let x = 0; x < logLen; x++) {
                        //data[x] = this.logsExport[x]
                        data[x] = {
                           "Extension Key": this.logsExport[x].api_key,
                           "Extension Name": (this.logsExport[x].apikey_name == "" || this.logsExport[x].apikey_name == null) ? "None" : this.logsExport[x].apikey_name,
                           "Host Name": (this.logsExport[x].host_name == null || this.logsExport[x].host_name == "") ? "None" : this.logsExport[x].host_name,
                           //"Website": encodeURIComponent(this.logsExport[x].url),
                           "Website": this.logsExport[x].url.replaceAll(";", "?"),
                           "Redirect URL": (this.logsExport[x].redirect_uri == "" || this.logsExport[x].redirect_uri == null) ? "None" : encodeURIComponent(this.logsExport[x].redirect_uri),
                           "Size (Kb)": (this.logsExport[x].filesize == null) ? 0 : this.logsExport[x].filesize,
                           "Login Field": (this.logsExport[x].has_password_field) ? "Yes" : "No",
                           "IP": this.logsExport[x].ip,
                           "Status": this.getStatusName(this.logsExport[x].is_safe, this.logsExport[x].unsafe_code),
                           "Block Type": this.logsExport[x].block_type,
                           "Version": this.logsExport[x].extension_version,
                           "Browser": (this.logsExport[x].user_agent !== "" && this.logsExport[x].user_agent !== null) ? (this.logsExport[x].user_agent.includes("Edg")) ? "Edge" : (this.logsExport[x].user_agent.includes("Chrome"))  ? "Chrome" : (this.logsExport[x].user_agent.includes("Firefox")) ? "Firefox" : "None" : "None",
                           "Date & Time": this.formatDate(this.logsExport[x].date_created)
                        }
                     }
                  }
                  else {
                     for (let x = 0; x < logLen; x++) {
                        data[x] = {
                           "Extension Key": this.logsExport[x].api_key,
                           "Extension Name": (this.logsExport[x].apikey_name == "" || this.logsExport[x].apikey_name == null) ? "None" : this.logsExport[x].apikey_name,
                           "Host Name": (this.logsExport[x].host_name == null || this.logsExport[x].host_name == "") ? "None" : this.logsExport[x].host_name,
                           // "Website": encodeURIComponent(this.logsExport[x].url),
                           "Website": this.logsExport[x].url.replaceAll(";", "?"),
                           "Redirect URL": (this.logsExport[x].redirect_uri == "" || this.logsExport[x].redirect_uri == null) ? "None" : this.logsExport[x].redirect_uri,
                           "Size (Kb)": (this.logsExport[x].filesize == null) ? 0 : this.logsExport[x].filesize,
                           "Login Field": (this.logsExport[x].has_password_field) ? "Yes" : "No",
                           "IP": this.logsExport[x].ip,
                           "Status": this.getStatusName(this.logsExport[x].is_safe, this.logsExport[x].unsafe_code),
                           "Block Type": this.logsExport[x].block_type,
                           "Date & Time": this.formatDate(this.logsExport[x].date_created)
                        }
                     }
                  }
               }

               // if (data != null) {
               //    if (data.length > 0) {
               //       for (let logLen = 0; logLen < data.length; logLen++) {
               //          delete data[logLen].account_id
               //          delete data[logLen].apikey_id
               //          delete data[logLen].id
               //          data[logLen].date_created = this.formatDate(data[logLen].date_created)
               //       }
               //    }
               // }

               try {
                  exportFromJSON({ data, fileName, exportType })
               } catch (err) {
                  console.error(err)
                  this.$toast.error("An error occured while exporting Log data.")
               }

               this.isLoading = false


            }, 5000);


         })

      },

      showPrintPreview() {

         var css = '@page { size: landscape; }',
            head = document.head || document.getElementsByTagName('head')[0],
            style = document.createElement('style');

         style.type = 'text/css';
         style.media = 'print';

         if (style.styleSheet) {
            style.styleSheet.cssText = css;
         } else {
            style.appendChild(document.createTextNode(css));
         }

         head.appendChild(style);


         this.showTable = true;
         window.print();
         this.showTable = false;
      },

      isNumber: function (evt) {
         evt = (evt) ? evt : window.event;
         var charCode = (evt.which) ? evt.which : evt.keyCode;
         if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) {
            evt.preventDefault();
         } else {
            return true;
         }
      },

      preventKeyPress: function (evt) {
         evt = (evt) ? evt : window.event;
         evt.preventDefault();
      },

      getStatusName(status, status_code) {
         switch (status) {
            case 0:
               if (status_code !== "" && status_code !== null) {
                  return `UNSAFE (${status_code})`
               } else {
                  return `UNSAFE`
               }
            case 1:
               return `SAFE`
            case 3:
               return `BLOCKED`
            default:
               return `UNCHECKED`
         }
      },

      getStatusClass(status) {
         switch (status) {
            case 0:
               return `text-color-unsafe`
            case 1:
               return `text-color-safe`
            case 3:
               return `text-color-blocked`
            default:
               return `text-color-unchecked`
         }
      },

      getTypeClass(type) {

         if (typeof text === 'string') {
            type = type?.toLowerCase()
         }

         switch (type) {
            case "phishing":
               return `text-color-phishing`
            case "categories":
               return `text-color-blocked`
            default:
               return `text-color-regular`
         }
      },

      StatusCheck() {
         console.log(this.filters["status"])
      },

      FilterOnOff() {
         //console.log(this.filterActive)
         this.filterActive = !this.filterActive

         if (this.filterActive) {
            this.$toast.success("Filters Turned On")
         } else {
            this.$toast.error("Filters Turned Off")
         }

         this.getLogHistory()
      },

      changeFilter(field_name) {
         this.filters[field_name] = !this.filters[field_name]
         this.getLogHistory()
      },

      ClearFilters() {
         //console.log(this.filters)
         this.filters["keyword"] = null
         this.filters["url"] = null
         this.filters["is_safe"] = -1
         this.filters["email"] = null
         this.filters["ext_api_key"] = null
         this.filters["date_from"] = null
         this.filters["date_to"] = null
         this.filters["min_upload_size"] = null
         this.filters["max_upload_size"] = null
         this.filters["has_password_field"] = false
         this.filters["oauth"] = false
         this.getLogHistory()
      },

      toUTC(date, isTo) {
         // return moment(date).format("YYYY/MM/DD")

         let dNow = moment(date)


         let _date = moment.utc(dNow).format()
         if (isTo) {
            _date = moment.utc(dNow).add(23, 'hours').add(59, 'minutes').add(59, 'seconds').format()
         }

         return _date
      },

      formatDate(date) {
         return moment(date).format("DD-MMM-YYYY @ HH:mm:ss")
      },

      formatDateFromUTC(date) {
         return moment(date).local().format("DD-MMM-YYYY @ HH:mm:ss")
      },

      formatDateFrom(date) {
         return moment(date).format("YYYY/MM/DD")
      },

      formatDateTo(date) {
         return moment(date).format("YYYY/MM/DD")
      },

      nextPage() {
         let isTrue = this.logCount >= this.pagination.pageSize
         isTrue ? this.pagination.page += 1 : ''
         isTrue ? this.getLogHistory() : null

      },

      onSearch() {

         if (this.filterActive == false)
            return

         this.pagination.page = 1
         this.logs = []

         this.debounceFn()
         //this.pagination.page = 1
      },

      async getExtensionKeys() {

         //console.log(this.$store.state.auth.organisation_uuid)


         await this.$axios.get("analytics/" + this.$store.state.auth.organisation_uuid + "/get-account-extension-keys")
            .then((response) => {
               this.extensionKeys = response.data.api_keys
            })
            .catch((error) => {
               //console.log(error)
               //console.log(error.response)
               console.log(error)
               this.$toast.error("An error has occured.")
            })
      },

      truncateText(text, limit) {

         if (text === null)
            return
         if (text === '')
            return

         if (text.length <= limit) {
            return text; // Return the original text if it's within the limit
         } else {
            return text.slice(0, limit) + '...'; // Truncate the text and add ellipsis
         }
      },

      trimQuestionMark(text) {
         let index = text.indexOf('?')

         if (index > 0) {
            return text.substring(0, index)
         } else {
            return text
         }
      },

      async getLogsForExport() {
         let apiPath = "analytics/" + this.$store.state.auth.organisation_uuid + "/search-account-log-history?page_size=" + this.pagination.pageSize + "&page=" + this.pagination.page + "&oauth=" + this.filterOAuthBy + "&has_password_field=" + this.filterLoginBy

         if (this.sorting.order != "") {
            apiPath += "&order_by=" + this.sorting.order
         }

         if (this.filterActive == true) {
            for (const [key, value] of Object.entries(this.filters)) {
               //console.log(`${key}: ${value}`);
               if (key == 'is_safe') {
                  if (value >= 0) {
                     apiPath += `&${key}=${value}`
                  }
               } else if (key == 'date_from') {
                  if ((value != "" || value >= 0) && value !== null) {
                     apiPath += `&${key}=${this.toUTC(value, false)}`
                  }
               } else if (key == 'date_to') {
                  if ((value != "" || value >= 0) && value !== null) {
                     console.log(value)
                     apiPath += `&${key}=${this.toUTC(value, true)}`
                  }
               } else {
                  if ((value !== "" || value >= 0) && value !== null) {
                     apiPath += `&${key}=${value}`
                  }
               }
            }

            apiPath += `&for_export=1`
         }

         await this.$axios.get(apiPath)
            .then((response) => {
               if (response.data.logs === "No Record Found") {
                  this.logsExport = []
               }
               else {
                  this.logsExport = response.data.logs
                  // this.isLoading = false
               }
            })
            .catch((error) => {
               console.log(error)
               this.$toast.error("An error has occured.")
               //this.$toast.error(error.response.message)
            })

      },

      async getLogHistory() {

         let apiPath = "analytics/" + this.$store.state.auth.organisation_uuid + "/search-account-log-history?page_size=" + this.pagination.pageSize + "&page=" + this.pagination.page + "&oauth=" + this.filterOAuthBy + "&has_password_field=" + this.filterLoginBy

         if (this.sorting.order != "") {
            apiPath += "&order_by=" + this.sorting.order
         }

         if (this.filterActive == true) {
            for (const [key, value] of Object.entries(this.filters)) {
               //console.log(`${key}: ${value}`);
               if (key == 'is_safe') {
                  if (value >= 0) {
                     apiPath += `&${key}=${value}`
                  }
               } else if (key == 'date_from') {
                  if ((value != "" || value >= 0) && value !== null) {
                     apiPath += `&${key}=${this.toUTC(value, false)}`
                  }
               } else if (key == 'date_to') {
                  if ((value != "" || value >= 0) && value !== null) {
                     apiPath += `&${key}=${this.toUTC(value, true)}`
                  }
               } else {
                  if ((value !== "" || value >= 0) && value !== null) {
                     apiPath += `&${key}=${value}`
                  }
               }
            }

            apiPath += `&for_export=0`
         }


         await this.$axios.get(apiPath)
            .then((response) => {
               if (response.data.logs === "No Record Found") {
                  //this.logs = []
                  this.logCount = 0
                  //this.$toast.error("No Records Found.")
               }
               else {
                  this.logs.push(...response.data.logs)
                  this.logCount = response.data.logs.length
               }

               // this.paginationData = response.data.pagination
               // this.pagination.totalItems = this.paginationData.total_count
               // this.pagination.totalPages = Math.ceil(this.paginationData.total_count / this.pagination.pageSize)
            })
            .catch((error) => {
               //this.$toast.error(error.response.data.message)
               console.log(error)
               this.$toast.error("An error has occured.")
            })
      },
   },

})


</script>
<style scoped>
.button-container {
   display: flex;
   gap: 15px;
   /* Adjust this value for the desired spacing */
}

.card {
   border: none;
}

.card-title {
   font-style: normal;
   font-weight: 400;
   font-size: 20px;
   color: #435666;
}

.table {
   border: 0px 0px 1px 0px;
   font-size: 15px
}

.input-group-append {
   cursor: pointer;
}

.control-status--active {
   color: #00A54F;
}

.control-status--archived {
   color: #EB1C24;
}

.control-status--draft {
   color: #F3994D;
}

.btn-info-outline {
   background-color: white;
   border-color: #00a0c1;
   color: #00a0c1;
}

.btn-info-outline:hover {
   background-color: #00a0c1;
   border-color: #00a0c1;
   color: whitesmoke;
}

.btn-info-outline-active {
   background-color: #00A54F;
   border-color: #00A54F;
   color: whitesmoke;
}

/*design for clear button of btn group */
.btn-outline-clear {
   color: #f3994d;
   background-color: transparent;
   background-image: none;
   border-color: #f3994d
}

.btn-outline-clear:hover {
   color: whitesmoke;
   font-weight: bold;
   background-color: #f3994d;
   border-color: #f3994d
}

.btn-outline-clear:focus,
.btn-outline-clear.focus {
   box-shadow: 0 0 0 .2rem rgba(119, 204, 204, 0.5)
}

.btn-outline-clear.disabled,
.btn-outline-clear:disabled {
   color: #f3994d;
   background-color: transparent
}

.btn-info:focus,
.btn-info:hover,
.btn-info:active {
   background-color: #00a0c1;
   border-color: #00a0c1;
   opacity: 0.9
}

.btn-info:disabled {
   background-color: #00343f;
   border-color: #00343f;
}

.btn-outline-info {
   color: #00a0c1;
   border-color: #00a0c1;
}

.btn-outline-info:focus,
.btn-outline-info:hover,
.btn-outline-info:active {
   color: #fff;
   background-color: #00a0c1;
   border-color: #00a0c1;
}


/* text color */
.text-color-unsafe {
   color: #FF7377
}

.text-color-safe {
   color: #00A54F
}

.text-color-unchecked {
   color: #00a0c1
}

.text-color-blocked {
   color: #f3994d
}

.text-color-regular {
   color: #f3994d
}

.text-color-phishing {
   color: #FF7377
}

.text-color-category {
   color: #00a0c1
}

.text-color-yes {
   color: #00A54F
}

.text-color-no {
   color: #00a0c1
}

.tr-color-light {
   background-color: #f5f5f5;
   border: #f5f5f5;
}

.print-table {
   display: none;
   /* Initially hide the print-friendly table */
}

.tbodyDiv {
   max-height: 300px;
   overflow-y: auto;
}

.tbody-flow tr {
   max-height: 35px;
}

.table-responsive {
   overflow: auto;
   /* max-height: 50vh; */
   max-height: 450px;
}
</style>
